import React, { PropTypes } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import moment from "moment-timezone";
import $ from "jquery";
import ReactConfirmAlert, { confirmAlert } from "react-confirm-alert";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import QRCode from "qrcode";
import { jsPDF } from "jspdf";
import {
  deleteDashboardUser,
  editDashboardUser,
  sendWelcomeMail,
  allowAppAccess,
  markCheckedIn,
  markApproved,
  resetPasswordModal,
  fetchPasscode,
  markCheckedOut,
} from "DashboardUserAction";
import { showError, showSuccess } from "ReduxErrorBar";
import {
  NEW_IMAGE_PATH,
  BASE_IMAGES_URL,
  COMMON_FAIL_MESSAGE,
  DATE_FORMAT_WITH_TIME,
  DEVELOPMENT_TYPE,
  converDateIntoLocal,
} from "Constants";
import EmailPreview from "./email-preview";
import LocaleStrings from "Languages";

class DashboardUserItem extends React.Component {
  constructor(props) {
    super(props);
    this.editUser = this.editUser.bind(this);
    this.deleteUser = this.deleteUser.bind(this);
    this.openResetPassword = this.openResetPassword.bind(this);
    this.state = {
      resetpassword: false,
      loading: false,
      allowingaccess: false,
      selectedUsers: [],
      showEmailPreviewModal: false,
      loadingcheckin: false,
    };
  }

  showEmailPreviewModal = (e) => {
    //this.setState({showEmailPreviewModal: true})
  };
  closeEmailPreviewModal = (e) => {
    //this.setState({showEmailPreviewModal: false})
  };

  sendMail = (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    var { email } = this.props.appUser;
    this.props.sendWelcomeMail(
      this.props.session,
      { email: email },
      (response) => {
        this.setState({ loading: false });
        if (response.success === 1) {
          this.props.showSuccess(LocaleStrings.user_message_welcome_email_sent);
        } else if (response.success === 3) {
          this.props.showSuccess(
            LocaleStrings.user_message_welcome_email_error1
          );
        } else if (response.success === 4) {
          this.props.showSuccess(
            LocaleStrings.user_message_welcome_email_error2
          );
        } else {
          this.props.showError(COMMON_FAIL_MESSAGE);
        }
      }
    );
  };

  openResetPassword() {
    this.props.resetPasswordModal({
      show: true,
      selecteduser: this.props.appUser,
    });
  }

  editUser() {
    let pageNo = this.props.currentPage;
    this.props.editDashboardUser(this.props.appUser);
    this.props.pagination(pageNo);
    this.props.fetchPasscode(
      this.props.session,
      this.props.appUser.email,
      (response) => {}
    );

    $(".user-main-backdrop-modal").removeClass("show");
    $(".user-main-backdrop-modal").addClass("hide");
  }

  deleteUser() {
    let pageNo = this.props.currentPage;
    if (this.props.pageDataLength == 1) {
      pageNo = pageNo - 1;
    }

    confirmAlert({
      title: LocaleStrings.user_title_delete_users,
      message: LocaleStrings.user_text_permanently_delete_user,
      confirmLabel: LocaleStrings.button_ok,
      cancelLabel: LocaleStrings.button_cancel,
      buttons: [
        {
          label: LocaleStrings.button_ok,
          onClick: () => {
            this.props.deleteDashboardUser(
              this.props.session,
              this.props.appUser,
              (response) => {
                if (response.success === 0) {
                  this.props.showError(COMMON_FAIL_MESSAGE);
                } else {
                  let user = this.props.appUser;
                  user.deleted = true;
                  this.props.showSuccess(
                    LocaleStrings.user_message_user_deleted
                  );
                  this.selectionCallback(user);
                  this.props.pagination(pageNo);
                  this.props.refreshTotalUser();
                }
              }
            );
          },
        },
        {
          label: LocaleStrings.button_cancel,
          onClick: () => {},
        },
      ],
    });
  }

  loginUser = () => {
    this.setState({ allowingaccess: true });
    this.props.allowAppAccess(
      this.props.session,
      { email: this.props.appUser.email },
      (response) => {
        this.setState({ allowingaccess: false });
        if (response.success === 0) {
          this.props.showError(response.message);
        } else {
          this.props.showSuccess(
            LocaleStrings.user_message_user_access_allowed
          );
        }
      }
    );
  };

  selectionCallback = (user) => {
    // var user = this.props.appUser;
    this.props.checkAndUncheckUsers(user);
  };

  markUserCheckedIn = () => {
    let { appUser, session, currentPage, pageDataLength } = this.props;
    let pageNo = currentPage;
    if (pageDataLength == 1) {
      pageNo = pageNo - 1;
    }

    this.setState({ loadingcheckin: true });
    this.props.markCheckedIn(session, appUser, (response) => {
      if (response.success) {
        this.props.pagination(pageNo);
        this.props.showSuccess(
          LocaleStrings.user_message_user_marked_checked_in
        );
        setInterval(() => {
          this.setState({ loadingcheckin: false });
        }, 700);
      } else {
        this.props.showError(COMMON_FAIL_MESSAGE);
      }
    });
  };

  markUserCheckedOut = () => {
    let { appUser, session, currentPage, pageDataLength } = this.props;
    let pageNo = currentPage;
    if (pageDataLength == 1) {
      pageNo = pageNo - 1;
    }

    this.setState({ loadingcheckin: true });
    this.props.markCheckedOut(session, appUser, (response) => {
      if (response.success) {
        this.props.pagination(pageNo);
        this.props.showSuccess(
          LocaleStrings.user_message_user_marked_checked_out
        );
        setInterval(() => {
          this.setState({ loadingcheckin: false });
        }, 700);
      } else {
        this.props.showError(COMMON_FAIL_MESSAGE);
      }
    });
  };

  markUserApproved = () => {
    let { appUser, session } = this.props;
    let pageNo = this.props.currentPage;
    if (this.props.pageDataLength == 1) {
      pageNo = pageNo - 1;
    }

    this.props.markApproved(session, appUser, (response) => {
      if (response.success) {
        this.props.showSuccess(LocaleStrings.user_message_user_marked_approved);
        this.props.pagination(pageNo);
      } else {
        this.props.showError(COMMON_FAIL_MESSAGE);
      }
    });
  };

  downloadQr = () => {
    var { appUser } = this.props;
    var orientation = "p";
    var pageWidth = 256;
    var pageHeight = 256;
    var templateX = 0;
    var templateY = 0;
    var eventlogowidth = pageWidth;
    var eventlogohight = pageHeight;

    const doc = new jsPDF(orientation, "pt", [pageWidth, pageHeight]);

    // With promises
    QRCode.toDataURL(appUser.userqrstring)
      .then((url) => {
        // console.log("if", url);
        var imgData = url;
        doc.addImage(
          imgData,
          "JPEG",
          templateX,
          templateY,
          eventlogowidth,
          eventlogohight
        );
        doc.save(`${appUser.firstname}.pdf`);
      })
      .catch((err) => {
        console.error("Error :- ", err);
      });
  };

  render() {
    let { session, appUser, settingData } = this.props;
    let { loadingcheckin } = this.state;
    var { eventtimezone, createdon } = this.props.eventDetails;
    var selectedUsers = this.props.selectedUsers;
    var index = _.findIndex(selectedUsers, function (curuser) {
      return curuser.appuserid === appUser.appuserid;
    });

    var checked = false;
    if (index >= 0) {
      checked = true;
    }
    var profileImageUrl = "../../style/images/custom-icons/user_2.png";

    if (appUser.profileurl) {
      profileImageUrl = `${BASE_IMAGES_URL}/${appUser.profileurl}?api_key=${session.apiKey}&session_token=${session.sessionToken}`;
    }

    var style = {
      width: "30px",
      height: "30px",
      backgroundImage: `url(${profileImageUrl})`,
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      borderRadius: "10px",
      backgroundPosition: "50% 50%",
    };

    var checkinTime = this.props.appUser.checkedin
      ? converDateIntoLocal(this.props.appUser.checkintime)
      : "";

    return (
      <tr style={checked ? { backgroundColor: "#fff" } : {}}>
        <td>
          <label
            className="custom-container-checkbox"
            style={{ marginTop: -1 }}
          >
            <input
              type="checkbox"
              onChange={() => this.selectionCallback(this.props.appUser)}
              checked={checked}
            />
            <span className="checkmark" />
          </label>
        </td>
        <td>
          <div className="vertical-align-center">
            <div className="mr-10">
              <div style={style}></div>
            </div>
            <div>
              {appUser.username}{" "}
              <span className="label-mandatory">
                {appUser.isadmin ? `(${LocaleStrings.admin})` : ""}
              </span>
            </div>
          </div>
        </td>
        {/* <td>
          <div className="vcenter">{appUser.email}</div>
        </td> */}
        {DEVELOPMENT_TYPE === "koachify" ? (
          ""
        ) : (
          <td>
            {appUser.checkedin ? (
              <OverlayTrigger key="refresh" placement="top">
                {({ ref, ...triggerHandler }) => (
                  <div className="toolitp-btn">
                    <Button
                      className="btn-custom-table-white"
                      type="button"
                      bsStyle="not-required"
                      spinColor="#105efb"
                      onClick={this.markUserCheckedOut}
                      loading={loadingcheckin}
                      disabled={loadingcheckin}
                      style={loadingcheckin ? { paddingLeft: 15 } : {}}
                    >
                      {LocaleStrings.button_checked_in}
                    </Button>
                    <span className="tooltiptext-tick-icon">
                      <span className="tag-label-effect-time">
                        {checkinTime}
                      </span>
                    </span>
                  </div>
                )}
              </OverlayTrigger>
            ) : (
              <Button
                className="btn-custom-table-white"
                type="button"
                bsStyle="not-required"
                spinColor="#105efb"
                onClick={this.markUserCheckedIn}
                loading={loadingcheckin}
                disabled={loadingcheckin}
              >
                {LocaleStrings.button_check_in}
              </Button>
            )}
          </td>
        )}
        {/* <td>
          <div className="">
            {this.props.appUser.isapproved ? (
              <i
                className="fa fa-check"
                aria-hidden="true"
                style={{ color: "#13e613", fontSize: 22 }}
              ></i>
            ) : (
              <Button
                className="btn btn-custom-table-white"
                type="button"
                onClick={this.markUserApproved}
              >
                {LocaleStrings.button_mark_approved}
              </Button>
            )}
          </div>
        </td> */}
        {/*<td>
          <div className="action-button vcenter">
            {
              this.state.viewpassword ?
              <div className="userpassword">{this.props.appUser.password} <button className="btn btn-default btn-sm btn-delete" onClick={this.toggleViewPasswordHide}> X </button></div>
              :<button className="btn btn-default btn-sm btn-edit" onClick={this.toggleViewPasswordShow}>View Password</button>
            }
          </div>
        </td>*/}
        <td>{converDateIntoLocal(appUser.createdon)}</td>
        <td>
          <div className="table-ation-td">
            {DEVELOPMENT_TYPE === "koachify" ? (
              ""
            ) : (
              <div className={`action-button`}>
                <Button
                  className="btn btn-custom-table-blue"
                  loading={this.state.loading}
                  type="button"
                  onClick={appUser.isactive == 1 ? this.sendMail : null}
                  disabled={appUser.isactive == 1 ? false : true}
                >
                  {LocaleStrings.button_send_welcome_email}
                </Button>
              </div>
            )}
            {DEVELOPMENT_TYPE === "koachify" ? (
              ""
            ) : (
              <div className="action-button">
                <Button
                  className="btn btn-custom-table-blue"
                  loading={this.state.allowingaccess}
                  type="button"
                  onClick={
                    appUser.isactive == 1 && appUser.userwaitlistmode == 0
                      ? this.loginUser
                      : null
                  }
                  disabled={
                    appUser.isactive == 1 && appUser.userwaitlistmode == 0
                      ? false
                      : true
                  }
                >
                  {LocaleStrings.button_allow_app_access}
                </Button>
              </div>
            )}
            {/* <div
              className="action-button"
              style={{
                paddingBottom: 5,
                marginLeft: "10px",
                marginRight: "10px",
              }}
            >
              <button
                className="i-custom-table-edit"
                onClick={this.downloadQr}
                title={LocaleStrings.qr}
              >
                <img
                  className="i-custom-normal"
                  src={`${NEW_IMAGE_PATH}download.png`}
                />
              </button>
            </div> */}
            <div className="action-button">
              <button className="i-custom-table-edit" onClick={this.editUser}>
                <img
                  className="i-custom-normal"
                  src="../../style/images/custom-icons/edit.svg"
                  alt="edit-user"
                />
              </button>
            </div>
            {(appUser.isadmin && session.userid == appUser.appuserid) ||
            appUser.issuperadmin ? (
              ""
            ) : (
              <div className="action-button">
                <button
                  className="i-custom-table-delete"
                  onClick={this.deleteUser}
                >
                  <img
                    className="button-delete-icon"
                    src="../../style/images/delete.png"
                    alt="delete-user"
                  />
                </button>
              </div>
            )}
          </div>
          {/*<Button className="btn btn-default btn-sm btn-welcome" type="button" onClick={this.showEmailPreviewModal}>Send Welcome Mail</Button>*/}
          {/*this.state.showEmailPreviewModal ? <EmailPreview  appUser={this.props.appUser} eventDetails={this.props.eventDetails} showEmailPreviewModal={this.state.showEmailPreviewModal}  closeEmailPreviewModal={this.closeEmailPreviewModal} emailCount='one'/> : ''*/}
        </td>
      </tr>
    );
  }
}

export var mapStateToProps = (state) => {
  return {
    session: state.session,
    settingData: state.SettingData.resource,
  };
};

export default connect(mapStateToProps, {
  deleteDashboardUser,
  allowAppAccess,
  editDashboardUser,
  sendWelcomeMail,
  markCheckedIn,
  markApproved,
  resetPasswordModal,
  showError,
  showSuccess,
  fetchPasscode,
  markCheckedOut,
})(DashboardUserItem);
